import React, { useState, useEffect } from "react";
import classNames from "classnames";
import { ReactComponent as BackToTopArrow } from "@ugg/shared/assets/svg/back-to-top.svg";

export const TIER_LIST_PAGE_SIZE = 15;
const TIER_LIST_SCROLL_PAGE_SIZE = 40;
const TIER_LIST_SCROLL_SCREEN = 400;

export const TableScrollHandler = () => {
  const [showBackToTop, setShowBackToTop] = useState(false);

  useEffect(() => {
    const onScroll = (e: Event) => {
      if (window.scrollY >= 450) {
        setShowBackToTop(true);
      } else if (window.scrollY < 450) {
        setShowBackToTop(false);
      }
    };

    window?.addEventListener("scroll", onScroll);

    return () => {
      window?.removeEventListener("scroll", onScroll);
    };
  }, []);

  const smoothScroll = (e: React.MouseEvent) => {
    window?.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  };

  return (
    <div
      className={classNames(
        `back-to-top-btn hover:cursor-pointer 
        sticky bottom-[30px] float-right mt-[10px] mr-[25px] rounded-full shadow-[0_1px_4px_0px_#0b0b23]`,
        { "!hidden": !showBackToTop },
      )}
      onClick={smoothScroll}
    >
      <BackToTopArrow className="fill-accent-blue-400 hover:fill-accent-blue-600" width={50} height={50} />
    </div>
  );
};

// If you have other hooks that reset the page size,
// make sure to call this one after those hooks
export function useLazyLoadTableRows({
  tableData,
  tableRef,
  pageSize,
  setPageSize,
}: {
  tableData: any[];
  tableRef: React.MutableRefObject<HTMLElement | null>;
  pageSize: number;
  setPageSize: (pageSize: number) => void;
}) {
  useEffect(() => {
    if (tableData && tableData.length <= pageSize) {
      return;
    }
    if (tableRef.current) {
      const { height, y } = tableRef.current.getBoundingClientRect();
      if (height - (window.innerHeight - y) < TIER_LIST_SCROLL_SCREEN) {
        setPageSize(pageSize + 20);
      }
    }
  }, [pageSize, tableData]);

  useEffect(() => {
    const onScroll = (e: Event) => {
      if (tableData && tableData.length <= pageSize) {
        return;
      }

      if (tableRef.current) {
        const { height, y } = tableRef.current.getBoundingClientRect();
        if (height - (window.innerHeight - y) < TIER_LIST_SCROLL_SCREEN) {
          setPageSize(pageSize + TIER_LIST_SCROLL_PAGE_SIZE);
        }
      }
    };

    if (window) {
      window.addEventListener("scroll", onScroll);

      return () => {
        window.removeEventListener("scroll", onScroll);
      };
    }
  }, [pageSize, tableData, setPageSize]);
}
